module.exports = __webpack_public_path__ + "static/media/img_page09_b.91dee588.png";